<template>
	<div v-if="authorNotFound" class="center-container">
			<h1>Author not found</h1>
			<p>Sorry, but there is no authour with that ID in our database. If this problem persists, contact <a href="mailto:support@bookplate.co">support@bookplate.co</a>.</p>
			<h2><router-link to='/'>Return Home</router-link></h2>
	</div>
	<list 
		v-else
		v-bind:title="'Books by ' + name"
		v-bind:readerId="0"
	>
		<a class="loading cover" v-if="booksWritten == '' || booksWritten == 'undefined' || booksWritten == null"></a>
		<a class="loading cover" v-if="booksWritten == '' || booksWritten == 'undefined' || booksWritten == null"></a>
		<a class="loading cover" v-if="booksWritten == '' || booksWritten == 'undefined' || booksWritten == null"></a>
		<a class="loading cover" v-if="booksWritten == '' || booksWritten == 'undefined' || booksWritten == null"></a>
		<router-link v-for="book in booksWritten" :key="book.title" class="cover" :to="{path:'/book/' + book.book_id}" v-bind:style="{ backgroundImage: 'url(' + book.cover_url + ')' }">"{{ book.title }}" book cover</router-link>
	</list>
</template>

<script>
	import List from '../layout/List.vue'

	export default
	{
		components: 
		{
			List
		},
		created () 
		{
			document.title = "Bookplate";
		},
		data () 
		{
			return {
				info: "",
				notFound: false
			}
		},
		mounted () 
		{
			try 
			{
				let vue = this;

				fetch('https://api.bookplate.co/author/' + this.authorId,
				{
					credentials: 'include'
				})
				.then(function(response)
				{
					if(response.status == 404)
					{
						vue.notFound = true;
						return "";
					}

					return response.json();
				})
				.then(json => this.info = json)
				.then(function (json) 
				{
					if(vue.notFound)
					{
						document.title = "Author not found | Bookplate";
					}
					else
					{
						document.title = json.name + " | Bookplate";
					}
				})
			}
			catch(e)
			{
				this.$alert("Something went wrong. Please try again in a moment, or contact support@bookplate.co. Error:" + e, "An error occured");
			}
		},
		computed: 
		{
			authorNotFound: function()
			{
				return this.notFound;
			},
			authorId: function() 
			{
				return this.$route.params.id;
			},
			name: function()
			{
				return this.info.name;
			},
			booksWritten: function()
			{
				return this.info.books;
			}
		},        
	}
</script>